import * as React from 'react'

const GoinFlow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='GoinFlow'
    fill='none'
    height='40'
    role='img'
    width='40'
    viewBox='0 0 40 40'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>GoinFlow</title>
    <path
      d='M20 5C11.729 5 5 11.729 5 20C5 28.271 11.729 35 20 35C28.271 35 35 28.271 35 20C35 11.729 28.271 5 20 5ZM20 8C26.617 8 32 13.383 32 20C32 26.617 26.617 32 20 32C13.383 32 8 26.617 8 20C8 13.383 13.383 8 20 8Z'
      fill='currentColor'
    />
    <path
      d='M20 11C15.038 11 11 15.038 11 20C11 24.962 15.038 29 20 29C24.962 29 29 24.962 29 20C29 15.038 24.962 11 20 11ZM20 26C16.691 26 14 23.309 14 20C14 16.691 16.691 14 20 14C23.309 14 26 16.691 26 20C26 23.309 23.309 26 20 26Z'
      fill='currentColor'
      fillOpacity='0.6'
    />
    <path d='M20 16V20L24 24' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export default GoinFlow



// WEBPACK FOOTER //
// ./src/components/icons/ui/GoinFlow.tsx